"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "fetchCartDetails", {
    enumerable: true,
    get: ()=>fetchCartDetails
});
const _graphqlRequest = require("graphql-request");
const _checkoutFragment = require("../fragments/checkout-fragment");
const fetchCartDetails = (0, _graphqlRequest.gql)`
    query FetchCartDetails(
        $retailerId: ID!
        $checkoutId: ID!
    ) {
        checkout(
            retailerId: $retailerId
            id: $checkoutId
        ) {
            ...checkoutFragment
        }
    }
    ${_checkoutFragment.CHECKOUT_FRAGMENT}
`;
